import { Col, Row, Text } from 'components';
import { currencies, theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';


const SpanText = styled.span`
  font-size: 28px;
  color: ${theme.GREY_60};
  font-weight: 700;
`;

const Total = ({ selected, setSelected, selectedRecurring, totalValue, originalPrice }) => {
  const user = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    { currency, cards } = user.billing,
    { t } = useTranslation(),
    foundCurrency = currencies.find(
      (x) => x.value.toLowerCase() === (currency || 'usd').toLowerCase()
    ),
    hasDiscount = totalValue < originalPrice;

  return (
    <Row marg="24px 0 0" between noFlex wid={isMobile ? '70%' : '100%'}>
      <Text h2>{t('common.total')}</Text>

      <Row noFlex>
        <Col noFlex>
          <Text h2>
            <SpanText>{foundCurrency.symbol}</SpanText>
            {(totalValue / 100)
              .toLocaleString(undefined, {
                style: 'currency',
                currency: currency || 'usd'
              })
              .slice(1)}
          </Text>

          {hasDiscount && (
            <Text
              align="right"
              col={theme.GREY_60}
              style={{
                textDecorationLine: 'line-through',
                textDecorationStyle: 'solid'
              }}
            >
              {(originalPrice / 100).toLocaleString(undefined, {
                style: 'currency',
                currency: currency || 'usd'
              })}
            </Text>
          )}
        </Col>
      </Row>
    </Row>
  );
};

export default Total;
